module.exports = __webpack_public_path__ + "roboto-regular-webfont.a0108c9e8e52ed6a5207.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-regular-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto-regular-webfont.svg
// module chunks = styles